import MainChat from '../component/chat-dashboard/chatsidebar';
import { Stack, Box, } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';

function ChatLayout({ }) {
    const theme = useTheme();
    const [selectedChat, setSelectedChat] = useState(null);

    const handleSelectChat = (chat) => {
        // console.log("Chat selected:", chat);
        setSelectedChat(chat);
    };

    const resetChatState = () => {
        setSelectedChat(null); // Reset selected chat
    }


    return (
        <>
            <MainChat selectedChat={selectedChat} onNewChat={resetChatState} />
            
        </>
    );
}

export default ChatLayout;